
export default function GoogleDoc({url, width, height}){

    if(!url) return <>Document indisponible</>

    let urlParams = '?embedded=true';
    let src = url + urlParams;

    return <iframe 
            title="Google Doc"
            src={src}
            border="0"
            frameBorder="0"
            width={width || '100%'}
            height={height || '600px'}
        >
            Document indisponible
    </iframe>


}